import React from "react";
import Card from 'theme/Card'
import Modal from 'theme/Modal';
import Text from "theme/Text";
import Button from 'theme/Button'
import _ from "lodash";
import { ThemedShared } from 'styles/themed'
import { StyleSheet, View } from 'react-native'
import { setData } from 'services/redux/data/actions'
import { dataConstants } from 'services/redux/data/constants'
import i18n from 'utils/i18n'
import { layoutStyles } from 'styles/layout'
import HelperString from 'utils/helper-string'

export const createAlerts = ( dispatch ) => {
	const HelperAlerts = {
		modalOpen: false,

		alert: ( title, text = null, buttons = null ) => {

			let renderedButtons = [];

			if( _.isEmpty( buttons ) ) {
				buttons = [
					{ text: i18n.t( 'basic.ok' ) },
				]
			}

			if( !_.isEmpty( buttons ) ) {
				renderedButtons = buttons.map( ( button, index ) => {
					let onPress = HelperAlerts.closeModal;

					if( _.isFunction( button.onPress ) ) {
						onPress = HelperAlerts.closeModal.bind( this, button.onPress );
					}

					return (
						<View style={ layoutStyles.flexOne } key={ `modalViewButton${index}` }>
							<Button
								key={ `modalButton${index}` }
								onPress={ onPress }
								style={ staticStyles.buttonMarginRight10 }
								status={ !_.isEmpty( button.status ) ? button.status : 'primary' }>

								{ button.text }
							</Button>
						</View>
					)
				} );
			}

			let modal = (
				<Modal
					visible={ true }
					backdropStyle={ ThemedShared.backdrop }
					style={ staticStyles.modalMaxWidth600 }
					key={ "AlertModal" }>

					<Card>
						<Choose>
							<When condition={ !HelperString.isEmptyString( text ) }>
								<View key={ "modalTitle"} >
									<Text category="h6" style={ staticStyles.textMarginBottom10}>
										{ title }
									</Text>
								</View>
								<View key={ "modalText"} >
									<Text category="p1">
										{ text }
									</Text>
								</View>
							</When>
							<Otherwise>
								<View  key={ "modalTitle"} >
									<Text category="p1">
										{ title }
									</Text>
								</View>
							</Otherwise>
						</Choose>

						{ renderedButtons.length > 0 && (
							<View
								key={ "modalButtons" }
								style={ staticStyles.viewFlexDirectionRowJustifyContentFlexEnd }  >

								{ renderedButtons }
							</View>
						)}
					</Card>
				</Modal>
			)

			HelperAlerts.registerModal( modal );
		},

		closeModal: ( onPress ) => {
			HelperAlerts.registerModal( null );
			if( _.isFunction( onPress ) ){
				onPress();
			}
		},

		registerModal: ( modal ) => {
			dispatch( setData( dataConstants.ALERT, modal ) );
		}
	}

	return HelperAlerts;
}


const staticStyles = StyleSheet.create({
	buttonMarginRight10: {
		marginRight: 10,
	},
	modalMaxWidth600: {
		maxWidth: 600,
	},
	textMarginBottom10: {
		marginBottom: 10,
	},
	viewFlexDirectionRowJustifyContentFlexEnd: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		marginTop: 20,
	},
});
